import Component from '@glimmer/component'
import { service } from '@ember/service'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import type { IntlService } from 'ember-intl'
import type { SkillsMasteredMsData } from 'teacher-ui-client/utils/student-events/fetchers/skills-mastered'

interface Signature {
  Element: HTMLDivElement
  Args: {
    data: SkillsMasteredMsData
  }
}

export class DashboardSkillsMasteredMs extends Component<Signature> {
  @service intl!: IntlService

  readonly categoryThemes = {
    number: 'text-juicy-orange-400',
    fractions: 'text-oceany-blue-300',
    operations: 'text-rexy-purple-200',
    measurement: 'text-purply-pink-300',
    geometry: 'text-wl-blue-250',
    data: 'text-juicy-orange-300',
  }

  get skillsMasteredCategoryData() {
    const { intl } = this

    const numberCategory = {
      title: intl.t(`reporting.charts.dashboard.skillsMastered.categories.number`),
      category: 'number',
      value: formatValue(this.args.data.number.average, { replaceZero: true }),
      theme: this.categoryThemes.number,
    }
    const fractionsCategory = {
      title: intl.t(`reporting.charts.dashboard.skillsMastered.categories.fractions`),
      category: 'fractions',
      value: formatValue(this.args.data.fractions.average, { replaceZero: true }),
      theme: this.categoryThemes.fractions,
    }
    const operationsCategory = {
      title: intl.t(`reporting.charts.dashboard.skillsMastered.categories.operations`),
      category: 'operations',
      value: formatValue(this.args.data.operations.average, { replaceZero: true }),
      theme: this.categoryThemes.operations,
    }
    const measurementCategory = {
      title: intl.t(`reporting.charts.dashboard.skillsMastered.categories.measurement`),
      category: 'measurement',
      value: formatValue(this.args.data.measurement.average, { replaceZero: true }),
      theme: this.categoryThemes.measurement,
    }
    const geometryCategory = {
      title: intl.t(`reporting.charts.dashboard.skillsMastered.categories.geometry`),
      category: 'geometry',
      value: formatValue(this.args.data.geometry.average, { replaceZero: true }),
      theme: this.categoryThemes.geometry,
    }
    const dataCategory = {
      title: intl.t(`reporting.charts.dashboard.skillsMastered.categories.data`),
      category: 'data',
      value: formatValue(this.args.data.data.average, { replaceZero: true }),
      theme: this.categoryThemes.data,
    }

    return [numberCategory, fractionsCategory, operationsCategory, measurementCategory, geometryCategory, dataCategory]
  }

  <template>
    <div data-test-skills-mastered class="mx-8 grid h-full grid-cols-2 items-center gap-x-16 gap-y-4" ...attributes>
      {{#each this.skillsMasteredCategoryData as |categoryData|}}
        <div class="text-center font-bold print:font-bold!" data-test-skills-mastered-stat={{categoryData.category}}>
          <div data-test-skills-mastered-value class="{{categoryData.theme}} text-3xl">
            {{categoryData.value}}
          </div>
          <div class="text-black" data-test-skills-mastered-title>{{categoryData.title}}</div>
          <hr class="border-dusty-black-100 mt-4 mb-0 border-b" />
        </div>
      {{/each}}
    </div>
  </template>
}

export default DashboardSkillsMasteredMs
